import { useCallback, useEffect, useState } from 'react';
import { message } from 'antd';
import { FIND, FIND_KEY, process } from '../Service/Api';

export const useFetchRegimes = (queries = '', skip = 0, limit = 10) => {
  const [data, setData] = useState({ data: [] });
  const [loading, setLoading] = useState(false);
  const [params, setParams] = useState({ queries, limit, skip });

  const getRegimes = useCallback(async () => {
    setLoading(true);
    const response = await process(FIND, 'regimes', {}, params);
    if (response?.ok) {
      setData(response.data);
    } else {
      message.error('Error al consultar los regimenes');
    }
    setLoading(false);
  }, [process, params]);

  useEffect(() => {
    getRegimes();
  }, [getRegimes]);

  const onChangeParams = (q = '', s = 0, l = 10) =>
    setParams({ queries: q, limit: l, skip: s });

  const update = () => getRegimes();

  return [data, loading, onChangeParams, update];
};

export const useFetchRegimesWithApiKey = (
  queries = '',
  skip = 0,
  limit = 10
) => {
  const [data, setData] = useState({ data: [] });
  const [loading, setLoading] = useState(false);
  const [params, setParams] = useState({ queries, limit, skip });

  const getRegimes = useCallback(async () => {
    setLoading(true);
    const response = await process(FIND_KEY, 'regimes', {}, params);
    if (response?.ok) {
      setData(response.data);
    } else {
      message.error('Error al consultar los regimenes');
    }
    setLoading(false);
  }, [process, params]);

  useEffect(() => {
    getRegimes();
  }, [getRegimes]);

  const onChangeParams = (q = '', s = 0, l = 10) =>
    setParams({ queries: q, limit: l, skip: s });

  const update = () => getRegimes();

  return [data, loading, onChangeParams, update];
};
